'use strict';

import mix from '../helpers/mix';
import jqueryUI from './vendor/jquery-ui';

if (!window.jqueryUiCssLoaded) {
    mix.loadCSS('css/jquery-ui.css');

    window.jqueryUiCssLoaded = true;
}

export default jqueryUI;
